const style = {
  actionCell: {
    sx: {
      width: 42,
    },
  },
  head: {
    sx: {
      visibility: 'visible',
    },
  },
} as const;

export default style;
